<mat-sidenav-container>
    <mat-sidenav #sidenav="matSidenav">
        <div class="menu">
            <div class="head">
                <div class="btn-icon" *ngIf="sidenav.mode ==='over'" (click)="sidenav.toggle()">
                    <mat-icon *ngIf="sidenav.opened">
                        close
                    </mat-icon>
                </div>
                <div class="titulo-config">
                    <p>Configurações</p>
                </div>
                <div class="user">
                    <img src="../../assets/logo-completo.png">
                    <span>{{usuario}}</span>
                </div>
            </div>
            <div class="opcoes">
                <input *ngIf="verificarPermissao(['lista_usuario', 'cadastro_usuario'])" type="submit" class="button"
                    value="Usuários" routerLink="../configuracao/usuarios" [routerLinkActive]="['active']">
                <input *ngIf="verificarPermissao(['lista_grupos', 'cadastro_grupos', 'atualizar_grupos'])" type="submit"
                    class="button" value="Grupos" routerLink="../configuracao/grupos" [routerLinkActive]="['active']">
                <input *ngIf="verificarPermissao(['lista_cliente'])" type="submit" class="button" value="Clientes"
                    routerLink="../configuracao/clientes" [routerLinkActive]="['active']">
                <input *ngIf="verificarPermissao(['acessar_shapes'])" type="submit" class="button" value="Shapes"
                    routerLink="../configuracao/shapes" [routerLinkActive]="['active']">
                <input *ngIf="verificarPermissao(['lista_contrato'])" type="submit" class="button" value="Contratos"
                    routerLink="../configuracao/contratos" [routerLinkActive]="['active']">
                <div class="position-relative d-inline-block" *ngIf="verificarPermissao(['listar_agviews_connect'])">
                    <input id="agviewsConnect" type="submit" class="button"
                        value="AGViews Connect" routerLink="../configuracao/agviewsConnect" [routerLinkActive]="['active']">
                    <span id="badge-mensagens" *ngIf="exibirBadge" class="badge bg-danger position-absolute top-0 start-100 translate-middle z-2">
                        {{qtdAgviewsConnectSemClienteEProduto}}
                    </span>
                </div>
                <input *ngIf="verificarPermissao(['exibir_pesquisas'])" type="submit" class="button" value="Pesquisa"
                    routerLink="../configuracao/pesquisa" [routerLinkActive]="['active']">
                <input *ngIf="verificarPermissao(['lista_agrupamento', 'lista_todos_agrupamento'])" type="submit"
                    class="button" value="Agrupamentos" routerLink="../configuracao/agrupamentos"
                    [routerLinkActive]="['active']">
                <input *ngIf="verificarPermissao(['acessar_licencas'])" type="submit" class="button" value="Licenças"
                    routerLink="../configuracao/licencas" [routerLinkActive]="['active']">
                <input id="relatorio-acessos-premocenter" *ngIf="verificarPermissao(['relatorio_acessos_premocenter'])"
                    type="submit" class="button" value="Relatório de acessos" (click)="exibirModalRelatorio()"
                    [routerLinkActive]="['active']">
                <input type="submit" class="button" value="Início" routerLink="../home">
                <pre></pre>
            </div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <div class="content">
            <div class="btn-icon" *ngIf="sidenav.mode === 'over'" (click)="sidenav.toggle()">
                <mat-icon id="menu" *ngIf="!sidenav.opened" class="material-icons-sharp">
                    menu
                </mat-icon>
            </div>
            <div class="rotas">
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>